module.exports = __webpack_public_path__ + "static/img/about_9.77a8501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_9.png
// module id = pkrB
// module chunks = 1